import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { WebUserMultiselectDropdownComponent } from './web-user-multiselect-dropdown.component';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [WebUserMultiselectDropdownComponent],
  exports: [WebUserMultiselectDropdownComponent]
})
export class WebUserMultiselectDropdownModule { }
